import type React from 'react';
import type { RouteObject } from 'react-router-dom';

/**
 * Lazy route helper
 * - يخليك تكتب lazy: lazyRoute(() => import('...'))
 * - ويضمن أن default export هو Component
 */
export const lazyRoute = (
  importer: () => Promise<{ default: React.ComponentType<any> }>
): NonNullable<RouteObject['lazy']> => {
  return async () => {
    const mod = await importer();
    return { Component: mod.default };
  };
};

/**
 * Lazy route لكن مع إمكانية تمرير props (للحالات مثل: <AccountingPeriod customProp="Ap" />)
 */
export const lazyRouteWithProps = <P extends object>(
  importer: () => Promise<{ default: React.ComponentType<P> }>,
  getProps: () => P
): NonNullable<RouteObject['lazy']> => {
  return async () => {
    const mod = await importer();
    const Comp = mod.default;
    return { Component: () => <Comp {...getProps()} /> };
  };
};
